var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"d-flex align-items-center mr-2 notifications-footer__btn",class:{'like-btn': _vm.isLike},on:{"click":_vm.onClickLike}},[_c('span',{staticClass:"material-icons mr-1"},[_vm._v(" thumb_up ")]),_c('span',[_vm._v(" いいね ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }